<template>
  <div class="recent-transaction">
    <div class="modal recent-transaction-modal" v-if="t">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <span class="tags has-addons has-text-weight-semibold is-pulled-right">
            <span class="tag is-link">Trip ID</span>
            <span class="tag is-grey">{{ tripID(t) }}</span>
          </span>
          <h1 class="has-text-link is-size-5 has-text-weight-semibold">Recent Trip Details</h1>
          <p class="has-text-grey has-text-weight-semibold">{{t.workflow_type_name}}</p>
          <br />
          <div class="media-content">
            <p>
              <i class="fa fa-clock has-text-warning" />
              <!-- &nbsp; -->
              {{ longScheduledTime(t) }}
            </p>
            <p>
              <i class="fa fa-map-marker-alt has-text-primary" />
              &nbsp;{{ $t("driver.pickup-at") }}
              <a>{{ transaction.data.pickup_stop.name }}</a>
            </p>
            <p v-if="transaction.data.dropoff_stop">
              <i class="fa fa-long-arrow-alt-down has-text-grey" />
              <br />
              <i class="fa fa-map-marker-alt has-text-link" />
              &nbsp;{{ $t("driver.dropoff-at") }}
              <a>{{ transaction.data.dropoff_stop.name }}</a>
            </p>
            <p>
              <i class="fa fa-coins has-text-success" />
              &nbsp;
              <span>
                <span v-if="t.state === 'alighted'">{{ prettyFare(t) }}</span>
                <span v-else>No Charge</span>
              </span>
            </p>
          </div>

          <hr />
          <div>
            {{ $t("passenger.need-help-with-ride")}}
            <br />
            <a
              class="button is-link is-rounded is-outlined"
              href="https://m.me/tukapp"
              style="width: 50vw; flex:box"
            >
              <i class="fab fa-facebook-messenger is-small" />
              &nbsp;{{ $t("profile.support") }}
            </a>&nbsp;
          </div>
        </section>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "RecentTransactionModal",
  data() {
    return {
      transaction: null
    };
  },
  computed: {
    t() {
      return this.transaction;
    },
    driverPic() {
      var driver = this.t.driver;
      if (!driver.profile_pic_url || driver.profile_pic_url === "") {
        return this.$store.state.birdProfilePic;
      }
      return driver.profile_pic_url;
    },
    prettyDate() {
      if (this.date) return this.date.toLocaleDateString();
      return false;
    },
    prettyTime() {
      if (this.time) {
        return this.date.toLocaleTimeString();
      }
      return false;
    }
  },
  mounted() {
    EventBus.$on("RECENT_TRANSACTION", t => {
      this.transaction = t;
      console.log("RECENT_TRANSACTION", t);
    });
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    tripID(t) {
      return t.id.substr(t.id.length - 5);
    },
    prettyFare(t) {
      if (t.data.fare) {
        if (t.data.fare.cash > 0) {
          return `฿ ${t.data.fare.cash} via Cash`;
        }
        if (!t.data.fare.tukpay) {
          return `Ask your driver for fare details`;
        }
        return `฿ ${t.data.fare.tukpay} via TukPay`;
      }
      return "Free of Charge";
    },
    patchTransaction() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.transaction.id,
          data: {
            data: { acknowledged: false, scheduled_time: new Date() }
          }
        })
        .then(() => this.updateTrips())
        .catch(err => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.closeModal();
        });
    }
  }
};
</script>

<style scoped>
.field {
  display: block;
  margin: auto;
}
img {
  border-radius: 8px;
  border: 2px solid gold;
  height: 80px;
  width: auto;
}
div.card-content {
  padding: 6px;
  overflow: hidden !important;
}
.columns,
.columns:last-child {
  margin: 0;
  padding: 0;
}
.column {
  padding: 2px;
}
.tag {
  padding: 0 4px;
}
hr {
  margin: 10px 0;
}
</style>